import {
  INVENTORY_CABANG_GET_FAIL,
  INVENTORY_CABANG_GET_REQUEST,
  INVENTORY_CABANG_GET_RESET,
  INVENTORY_CABANG_GET_SUCCESS,
} from "../constants/InventoryCabangConstants";

export const inventoryModul_get_cabang_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case INVENTORY_CABANG_GET_REQUEST:
      return { loading: true };
    case INVENTORY_CABANG_GET_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case INVENTORY_CABANG_GET_FAIL:
      return { loading: false, error: action.payload };
    case INVENTORY_CABANG_GET_RESET:
      return {};
    default:
      return state;
  }
};
